// extracted by mini-css-extract-plugin
module.exports = {"error_wrap":"__404_error_wrap__sxKba","error_code":"__404_error_code__SUTFs","error_text":"__404_error_text__XTBbT"};